import React from 'react';
import styles from './Spinner.module.scss';

function Spinner() {
  return <div className={styles.spinner} role="status" aria-live="polite" aria-label="Please wait"></div>;
}

export default Spinner;
